import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import RenderContent from 'app/components/layout/RenderContent';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import SectionGroup from 'app/components/general/SectionGroup';
import HeaderThin from 'app/components/layout/HeaderThin';
import { IApplicationState } from 'app/types/state';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import * as teamActions from 'app/ducks/teams/actions';
import * as teamMemberActions from 'app/ducks/teamMembers/actions';
import * as paymentActions from 'app/ducks/payments/actions';
import * as paymentCollectionActions from 'app/ducks/paymentCollections/actions';
import * as reminderActions from 'app/ducks/reminders/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamSelectors from 'app/ducks/teams/selectors';
import * as userSelectors from 'app/ducks/users/selectors';
import * as teamMemberSelectors from 'app/ducks/teamMembers/selectors';
import * as paymentSelectors from 'app/ducks/payments/selectors';
import * as paymentCollectionSelectors from 'app/ducks/paymentCollections/selectors';
import * as reminderSelectors from 'app/ducks/reminders/selectors';
import DashboardUpcomingMatches from '../DashboardUpcomingMatches';
import DashboardPaymentRequestSummary from '../DashboardPaymentRequestSummary';
import DashboardActivePaymentRequests from '../DashboardActivePaymentRequests';

interface IProps {
  teamId: string;
  actions: any;
  users: any;
  teamMembers: any;
  payments: any;
  teams: any;
  paymentCollections: any;
  organisations: any;
  reminders: any;
  match: any;
  appReady: boolean;
}

interface IState {
  selectedTeam: any;
}

const selector = (state): any => ({
  teams: {
    ...teamSelectors.getTeams(state),
    getPaymentIds: (teamId) => teamSelectors.getPaymentIds(state, teamId),
    getTeamMemberIds: (teamId) => teamSelectors.getTeamMemberIds(state, teamId),
    getCurrentTeam: () => teamSelectors.getCurrentTeam(state),
  },
  teamMembers: teamMemberSelectors.getTeamMembers(state),
  users: userSelectors.getUsers(state),
  payments: paymentSelectors.getPayments(state),
  paymentCollections: paymentCollectionSelectors.getPaymentCollections(state),
  reminders: reminderSelectors.getReminders(state),
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(
  teamActions,
  teamMemberActions,
  paymentActions,
  paymentCollectionActions,
  reminderActions,
);

const DashboardSingleTeam: FC<IProps> = (props: IProps = {
  teamId: undefined,
  actions: undefined,
  users: undefined,
  teamMembers: undefined,
  payments: undefined,
  teams: undefined,
  paymentCollections: undefined,
  organisations: undefined,
  reminders: undefined,
  match: undefined,
  appReady: false,
}) => {
  const [filterStatus, setFilterStatus] = useState('pending');

  useEffect(() => {
    props.actions.selectTeam(props.teamId);
  }, [props.teamId]);

  return (
    <div>
      <div className="row">
        <div className="col">
          <DashboardUpcomingMatches
            {...props}
            groupIds={_.uniq(_.map(props.teams.currentTeam?.groups, (g) => g?.id))}
            orgIds={_.uniq(_.map(props.teams.currentTeam?.organisations, (o) => o?.id))}
            teamId={props.teams.currentTeam?.id}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <DashboardPaymentRequestSummary
            {...props}
            teamId={props.teams.currentTeam?.id}
            setFilterStatus={setFilterStatus}
          />
        </div>
      </div>
      <div className="row with-margin-top-extra">
        <div className="col">
          <DashboardActivePaymentRequests
            {...props}
            teamId={props.teams.currentTeam?.id}
            filterStatus={filterStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(DashboardSingleTeam);
